// Date math for the super-admin "Backdated copy" tool: a duplicated count
// session keeps the original time-of-day on every timestamp, shifted by a
// whole number of days so the copy lands on the chosen calendar date.

/**
 * Millisecond delta that moves `fromDateLike` (a 'YYYY-MM-DD' session_date
 * string or a timestamp) onto the calendar day `toDateStr` ('YYYY-MM-DD').
 * Both sides are normalised to local midnight so the delta is always a whole
 * number of days regardless of the original time-of-day.
 */
export function computeDayShiftMs(fromDateLike, toDateStr) {
  const toMidnight = (d) => {
    const c = new Date(d);
    c.setHours(0, 0, 0, 0);
    return c;
  };
  // Date-only strings are parsed at noon so timezone offsets can never roll
  // them onto a neighbouring day before the midnight normalisation.
  const asLocalDay = (value) =>
    /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? new Date(`${value}T12:00:00`) : new Date(value);
  return toMidnight(asLocalDay(toDateStr)) - toMidnight(asLocalDay(fromDateLike));
}

/** Shift an ISO timestamp by `deltaMs`, passing null/undefined through. */
export function shiftTimestamp(value, deltaMs) {
  return value ? new Date(new Date(value).getTime() + deltaMs).toISOString() : null;
}
